module.exports = __webpack_public_path__ + "static/img/bg-en.37bf9bbd.png";